import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-cafae-dialog',
  templateUrl: './cafae-dialog.component.html',
  styleUrls: ['./cafae-dialog.component.scss']
})
export class CafaeDialogComponent implements OnInit {
  documentoSeleccionado: any;
  comunicadoSeleccionado: any;

  documentos = [
    {
      titulo: 'Comunicado N° 01',
      uri: 'assets/images/cafae_2028/Comunicado_1.jpg',
      link: ''
    },
    {
      titulo: 'Comunicado N° 02',
      uri: 'assets/images/cafae_2028/Comunicado_2.jpg',
      link: 'https://drive.google.com/file/d/1oXBbmvY69qmCcApqCR4zra0MxOxQEaYE/view'
    },
    {
      titulo: 'Comunicado N° 05',
      uri: 'assets/images/cafae_2028/Comunicado_3.jpg',
      link: 'https://drive.google.com/file/d/1fSu7FHL1zZwA4NSHTB0W4wboiNkGckKM/view'
    },
    {
      titulo: 'Comunicado N° 06',
      uri: 'assets/images/cafae_2028/Comunicado_4.jpg',
      link: 'https://drive.google.com/drive/folders/1yREA0Rl6__6f91RNM6vkwc0mkTAmczUi'
    },
    {
      titulo: 'Comunicado N° 07',
      uri: 'assets/images/cafae_2028/Comunicado_5.jpg',
      link: 'https://drive.google.com/drive/folders/118Axq9puNhmiI-MGYskTgzGaTDj_tqtx'
    },
    {
      titulo: 'Comunicado N° 08',
      uri: 'assets/images/cafae_2028/Comunicado_8.jpg',
      link: 'https://drive.google.com/drive/folders/11lYiBEBIDQSam4oge2RQrI-XrQLv9YP5'
    },
    {
      titulo: 'Comunicado N° 09',
      uri: 'assets/images/cafae_2028/Comunicado_9.png',
      link: 'https://drive.google.com/file/d/18dIuQIswi2J0-C4z3YJsAryXTwWzmt7Y/view'
    },
    {
      titulo: 'Comunicado N° 10',
      uri: 'assets/images/cafae_2028/comunicado_10.jpg',
      link: 'https://drive.google.com/file/d/1K92IHYvc2IwUFTMMSkuTGVvke8z45rnZ/view'
    },
    
  ];

  constructor(
    private dialogRef: MatDialogRef<CafaeDialogComponent>,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.seleccionarDocumento(this.documentos[0]);
  }

  seleccionarDocumento(doc: any): void {
    this.documentoSeleccionado = doc;
  }

  abrirLink(): void {
    if (this.documentoSeleccionado.link && this.documentoSeleccionado.link.trim() !== '') {
      window.open(this.documentoSeleccionado.link, '_blank');
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }
  
}